import React from 'react'
import {uploadFormComponents} from '@modifi/plugin-documents'

import FileEntry from './components/FileEntry'

const ExistingFilesList = ({components, ...props}: any) => (
  <uploadFormComponents.ExistingFilesList
    canChangeVisibility={false}
    {...props}
    components={{fileEntry: FileEntry, ...components}}
  />
)

export default ExistingFilesList
